
<dashboardnav>

    <cradua-incident-event-type
    [incidentEventTypes]="incidentEventTypes$ | async"
    (incidentEventType)="onSubmitIncidentEventType($event)"
    (deleteIncidentEventTypeEvent)="onDeleteIncidentEventType($event)"
    *ngIf="(isLoadingIncidentEventType$ | async ) === false"
    >
  </cradua-incident-event-type>

    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoadingIncidentEventType$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
